import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export const DetailsButton = ({ onClick, isLoading }) => {
  const { t } = useTranslation();

  return (
    <Button onClick={onClick} disabled={isLoading}>
      {t(isLoading ? 'Loading' : 'See details')}
      {isLoading ? null : <i className="bx bx-right-arrow-alt" />}
    </Button>
  );
};

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background: transparent;
  color: #343a40;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  i {
    font-size: 16px;
    color: #484848;
    display: flex;
  }

  &:hover {
    background: #f7fafc;
  }

  &:disabled {
    background: #f7fafc;
    cursor: wait;
    color: #74788d;
  }
`;

DetailsButton.propTypes = {
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
};
